import http from 'hub-http/clients/apiClient';
export default {
  fetchUsersByScope: scope => {
    return http.get(`permissions-skynet/v1/scopes/app/${scope}/hub-users`);
  }
};